import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  getOrganisationGeofence,
  upsertOrganisationGeofence,
} from "../lib/geofenceApi";

export interface GeofenceRow {
  id: string;
  organisation_id: number;
  address: string | null;
  center_lat: number | null;
  center_lng: number | null;
  polygon: { type: "Polygon"; coordinates: number[][][] } | null;
  updated_at: string;
  updated_by: string | null;
}

export const useGeofence = (organisationId: number | null | undefined) => {
  return useQuery<GeofenceRow | null>(
    ["organisation-geofence", organisationId],
    () => getOrganisationGeofence(organisationId as number),
    {
      enabled: Boolean(organisationId),
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );
};

interface UpsertArgs {
  organisationId: number;
  address: string | null;
  center: { lat: number; lng: number } | null;
  polygon: { type: "Polygon"; coordinates: number[][][] } | null;
}

export const useUpsertGeofence = () => {
  const qc = useQueryClient();
  return useMutation((args: UpsertArgs) => upsertOrganisationGeofence(args), {
    onSuccess: (_row, args) => {
      qc.invalidateQueries(["organisation-geofence", args.organisationId]);
    },
  });
};
